// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.object.set-prototype-of.js
 ** module id = 630
 ** module chunks = 0
 **/